import { render } from "./BoxProgrammPlaylistLanding.vue?vue&type=template&id=7fc5be94&scoped=true"
import script from "./BoxProgrammPlaylistLanding.vue?vue&type=script&lang=js"
export * from "./BoxProgrammPlaylistLanding.vue?vue&type=script&lang=js"

import "./BoxProgrammPlaylistLanding.vue?vue&type=style&index=0&id=7fc5be94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc5be94"]])

export default __exports__